import './SpecificationDocument.scss';

import { useQuery } from '@apollo/client';
import React from 'react';
import { Redirect, useParams } from 'react-router';

import AUTOCOMPLETE_PRODUCT_LABELS from 'api/queries/AUTOCOMPLETE_PRODUCT_LABELS';
import GET_MODEL_SPECIFICATION from 'api/queries/GET_MODEL_SPECIFICATION';
import Loader from 'atoms/Loader/Loader';
import Dashboard from 'layout/templates/Dashboard/Dashboard';

import DocumentView from './DocumentView';

function SpecificationDocument({ includeComponents = false }) {
  const { modelSpecificationId } = useParams();

  const { data, loading, error } = useQuery(GET_MODEL_SPECIFICATION, {
    variables: { modelSpecificationId },
  });

  const { data: productLabelsData, loading: productLabelsLoading } = useQuery(
    AUTOCOMPLETE_PRODUCT_LABELS,
  );

  if (error || data?.node === null) {
    return <Redirect to="/specifications" />;
  }

  if (loading || productLabelsLoading) {
    return (
      <Dashboard>
        <Loader />
      </Dashboard>
    );
  }

  return (
    <DocumentView
      data={data}
      productLabels={productLabelsData}
      includeComponents={includeComponents}
    />
  );
}

export default SpecificationDocument;
